<template>
  <div
    v-if="data"
    :class="{
      'container mx-auto': true,
    }"
  >
    <div
      :class="{
        'grid grid-cols-12': true,
      }"
    >
      <div
        :class="{
          'col-span-12 md:col-span-4 md:pr-6 lg:pr-0': true,
        }"
      >
        <PtcPicture
          v-if="data.headshot && data.headshot.asset"
          provider="sanity"
          :src="data.headshot.asset._ref"
          :img-attrs="{
            class: {
              'max-w-200px max-h-200px mx-auto md:max-w-180px md:max-h-180px lg:max-w-200px lg:max-h-200px': true,
            },
          }"
          :modifiers="{
            crop: data.headshot.crop,
            hotspot: data.headshot.hotspot,
          }"
          :alt="resolvedImage?.altText || 'speaker headshot'"
        />
      </div>
      <div
        :class="{
          'col-span-12 md:col-span-8 md:ml-1 lg:ml-0': true,
        }"
      >
        <div
          :class="{
            'mb-8 mt-25px flex flex-col md:mt-0': true,
          }"
        >
          <span
            :class="{
              'relative mb-10px pb-14px text-21px font-black uppercase leading-4 tracking-[0.0375rem] text-www-color-neutral-medium-dark': true,
              'after:absolute after:bottom-0 after:left-0 after:h-1 after:w-52px after:bg-www-color-primary-lighter': true,
            }"
            >{{ data.name }}</span
          >
          <span
            :class="{
              'text-sm leading-6 text-www-color-neutral-medium-dark': true,
            }"
            >{{ data.jobTitle }}</span
          >
          <span
            :class="{
              'text-sm font-semibold leading-6 text-www-color-neutral-medium-dark': true,
              hidden: !showEmail,
            }"
            >{{ data.emailAddress }}</span
          >
          <span
            :class="{
              'text-sm font-semibold leading-6 text-www-color-neutral-medium-dark': true,
              hidden: !showCompany,
            }"
            >{{ data.company }}</span
          >
        </div>
        <p
          :class="{
            'text-base leading-7 lg:text-lg lg:leading-8': true,
          }"
        >
          {{ data.bio }}
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import PtcPicture from '~/components/Atmos/PtcPicture/PtcPicture.vue';
import type { SpeakerBio } from '~/sanity/types';
import { useRefsStore } from '~/composables/refsStore';

const { getResolvedPerson, getResolvedImage } = useRefsStore();
const props = defineProps<SpeakerBio>();
const data = await getResolvedPerson(props.speakerBio?.reference?._ref);
const resolvedImage = await getResolvedImage(data.value?.headshot?.asset?._ref);
</script>

<style></style>
